import { Box, Separator as SambaSeparator } from '@betterment/samba-react';

export function Separator() {
  return (
    <Box css={{ py: 'space.150' }}>
      <SambaSeparator css={{ bg: 'primitives.white.100alpha30' }} />
    </Box>
  );
}

Separator.displayName = 'Nav.Separator';
